/*
page-products.js
    product archive support
    filtering controls - handles both category filters & product finder filters
 */

/* eslint-disable no-use-before-define */

(($) => {
    // make mobile filters sticky
    const $stickyFilter = $('.products-filter').sticky({ topSpacing: 70 });
    // update sticky filter when open/closing filter submenus
    //   fixes issue with sizing of products-filter before scroll
    $('#filter-collapse').on('shown.bs.collapse hidden.bs.collapse', () => {
        $stickyFilter.sticky('update');
    });

    const $body = $('body');
    const $win = $(window);

    const $cats = $('.js-product-category');

    const $productStorage = $('.products-storage .js-product');
    const $productDisplay = $('.products-list');
    // add schema.org attributes after load, to avoid error on empty list
    $productDisplay.attr('itemscope', '');
    $productDisplay.attr('itemtype', 'http://schema.org/ItemList');

    const { termData } = CLOROX_GLOBAL;
    const $title = $('.js-title');
    const $description = $('.js-description');
    const defaultTitle = $title.data('default');
    const titleTemplate = $title.data('title-template');
    const defaultDescription = $description.data('default');
    const pageTitlePostfix = document.title.substr(document.title.indexOf(' | '));

    // shared clear control
    $('.js-clear-filter').on('click', () => {
        $body.trigger('clear-filter');
    });

    // handle clearing of one filter set when starting the other
    let reloading = null; // set to cat or finder when reloading
    $body.on('reloading', (e, type) => {
        reloading = type;
        $body.trigger('clear-filter');
        reloading = null;
    });

    // filtering by category
    $(() => {
        // main function for showing correct products in grid & updating counts
        function reload() {
            if (!reloading) {
                $body.trigger('reloading', 'cat');
            }

            // get previous lazy loader object & destroy
            // prevents old obj from loading imgs that are no longer displayed
            const lazyLoader = $('.lazy-product-tile', $productDisplay).data('plugin_lazy');
            if (lazyLoader) {
                lazyLoader.destroy();
            }

            // remove current set of products from display
            $productDisplay.children().remove();

            // build filter for new set of products
            let filter = '*';
            const catArray = [];
            $cats.each((i, el) => {
                const $this = $(el);
                if ($this.hasClass('active')) {
                    const cat = $this.data('catid');
                    filter = `${filter}.js-cat-${cat}`;
                    catArray.push(cat);
                }
            });
            $body.trigger('updateurl', [catArray]);
            updateHeader(catArray);

            // show the selected items
            let $clones = $productStorage.filter(filter).clone();
            $clones = sortProductTiles($clones, catArray);
            handleSingleScent($clones, catArray); // change img & link if single scent selected
            $productDisplay.append($clones);
            $('.lazy-product-tile', $productDisplay).Lazy();

            // product & filter counts
            $('.js-product-count').text($clones.length);
            const filterCount = $cats.filter('.active').length;
            if (filterCount) {
                $('.js-filter-count').text(filterCount);
                // don't use show to avoid showing on non-mobile
                $('.js-show-when-filtering').css('display', '');
            } else {
                $('.js-show-when-filtering').css('display', 'none');
            }
            // handle cat parent counts (mobile display only)
            $('.js-filter-header').each((i, el) => {
                const $this = $(el);
                const count = $this.closest('.js-cat-panel').find('.js-product-category.active').length;
                $('.js-cat-filter-count', $this).text(count ? `(${count})` : '');
            });

            // update category counts & disable filters as necessary
            $cats.each((i, el) => {
                const $this = $(el);
                const cat = $this.data('catid');
                const count = $clones.filter(`.js-cat-${cat}`).length;
                $('.js-cat-count', $this).text(count);
                if (!count) {
                    $this.addClass('disabled').attr('aria-disabled', 'true').find('input').attr('tabindex', '-1');
                } else {
                    $this.removeClass('disabled').attr('aria-disabled', 'false').find('input').attr('tabindex', '0');
                }
            });
        }

        function updateHeader(cats) {
            if (!cats.length) {
                // no cats
                document.title = defaultTitle + pageTitlePostfix;
                $title.html(defaultTitle);
                $description.html(defaultDescription);
            } else if (cats.length === 1) {
                // single cat
                document.title = termData[cats[0]].pageTitle + pageTitlePostfix;
                // use title template to specify title unless there is an override
                //  for this cat
                if (termData[cats[0]].headingOverride) {
                    $title.html(termData[cats[0]].headingOverride);
                } else {
                    const newTitle = titleTemplate.replace('%', termData[cats[0]].name);
                    $title.html(newTitle);
                }
                // $title.html(termData[cats[0]].name + ' ' + defaultTitle);
                const desc = termData[cats[0]].description;
                $description.html(desc || defaultDescription);
            } else {
                // multiple cats
                document.title = defaultTitle + pageTitlePostfix;
                $title.html(defaultTitle);
                $description.html(defaultDescription);
            }
        }

        // sort product tiles based on product sort order lists
        //  there is one for the page & can be overridden by categories
        function sortProductTiles($products, catArray) {
            // get sort list to use
            let sortOrder;
            if (catArray.length === 1 && CLOROX_GLOBAL.termData[catArray[0]].sort_order) {
                sortOrder = CLOROX_GLOBAL.termData[catArray[0]].sort_order;
            } else {
                sortOrder = CLOROX_GLOBAL.product_sort_order;
                if (!sortOrder) {
                    sortOrder = [];
                }
            }
            sortOrder = sortOrder.map((x) => +x);

            // return sorted list
            //  based of sortorder array and followed by non-list items alpha
            return $products.sort((a, b) => {
                const $a = $(a);
                const $b = $(b);
                const i = sortOrder.indexOf($a.data('id'));
                const j = sortOrder.indexOf($b.data('id'));
                if (i === -1 && j === -1) {
                    const nameA = $('.product-name', $a).text();
                    const nameB = $('.product-name', $b).text();
                    return nameA < nameB ? -1 : 1;
                }
                if (i === -1) {
                    return 1;
                }
                if (j === -1) {
                    return -1;
                }

                return i < j ? -1 : 1;
            });
        }

        // when single scent cat is selected
        // update images & links for that scent
        function handleSingleScent($tiles, catArray) {
            let scent;
            const scentCount = catArray.reduce((acc, cat) => {
                if (CLOROX_GLOBAL.termData[cat].scent) {
                    scent = cat;
                    return acc + 1;
                }
                return acc;
            }, 0);
            if (scentCount === 1) {
                $tiles.each((i, el) => {
                    // update image
                    const $img = $('img', $(el));
                    $img.attr('src', $img.data(`scentimg-${scent}`));
                    $img.attr('data-src', $img.data(`scentimg-${scent}`));

                    // update link
                    const $a = $img.closest('a');
                    $a.attr('href', `${$a.attr('href') + scent}/`);
                });
            }
        }

        // filtering handling
        $cats.on('click', function onclick() {
            const $this = $(this);
            if ($this.hasClass('disabled')) {
                return;
            }
            $this.toggleClass('active');
            reload();
        });
        $cats.on('keypress', function onClick(e) {
            if (e.which === 13) {
                $(this).click();
            }
        });

        // set filters based on url
        $body.on('setfilters', (e, catsArray) => {
            $cats.removeClass('active');
            $.each(catsArray, (i, cat) => {
                if (cat) {
                    $cats.filter(`[data-catid="${cat}"]`).addClass('active');
                }
            });
            reload();
        });

        // handle clear button press
        $body.on('clear-filter', () => {
            if (reloading !== 'cat') {
                $cats.removeClass('active');
                reload();
            }
        });

        // open correct filter parent based on current filters
        // used when restoring from url
        $body.on('restore-filter-collapse', () => {
            // move to separate restore - used at startup & popstate
            // make sure parent cat is open for an active cat
            const $activeFilters = $('.js-product-category.active');
            if ($activeFilters.length && !$('#filter-collapse .collapse.in').find($activeFilters).length) {
                $activeFilters.first().closest('.collapse').parent().find('.js-filter-header').click();
            }
        });

        // mobile UI handling
        // open & close popup styled filter list
        $('.js-mobile-filter-open').on('click', () => {
            $('div.products-filter').addClass('open');
        });
        $('.js-mobile-filter-close').on('click', () => {
            $('#filter-collapse').collapse('hide');
            $('div.products-filter').removeClass('open');
        });
    });

    // url, history, state handling
    $(() => {
        // handle initial load
        const parts = window.location.pathname.split('/');
        // console.log(parts);
        if (parts[3]) {
            const cats = parts.slice(3);
            $body.trigger('setfilters', [cats]);
            window.history.replaceState(
                {
                    cats,
                },
                null
            );
        } else {
            // init full load of products
            $body.trigger('reloading', 'init');
        }
        $body.trigger('restore-filter-collapse');

        // flag to prevent setting history state on restore from history
        let disableUpdateUrl = false;

        // update history event
        $body.on('updateurl', (e, cats) => {
            if (disableUpdateUrl) return;

            const urlBase = translatedStrings.urls['/products/'];

            if (!Array.isArray(cats) || !cats.length) {
                // no cats
                window.history.pushState(
                    {
                        cats,
                    },
                    null,
                    urlBase
                );
            } else if (cats.length === 1) {
                // single cat
                window.history.pushState(
                    {
                        cats,
                    },
                    null,
                    `${urlBase + translatedStrings.product_category}/${cats[0]}/`
                );
            } else {
                // multiple cats
                // sort & join into path
                window.history.pushState(
                    {
                        cats,
                    },
                    null,
                    `${urlBase + translatedStrings.product_category}/${cats.sort().join('/')}/`
                );
            }
        });

        // restore from history event
        $win.on('popstate', () => {
            disableUpdateUrl = true;
            const { state } = window.history;
            if (state && state.cats) {
                $body.trigger('setfilters', [state.cats]);
                $body.trigger('restore-filter-collapse');
            } else {
                $body.trigger('clear-filter');
            }
            disableUpdateUrl = false;
        });
    });

    // hide filters that don't apply to current product list
    //  happens with prods hidden for certain countries
    $(() => {
        $cats.each((i, el) => {
            const $filter = $(el);
            const catid = $filter.data('catid');
            if (!$productStorage.filter(`.js-cat-${catid}`).length) {
                $filter.hide();
            }
        });
    });
})(jQuery);
